import { escapeHTML } from "../../render/ui-helpers.js";

export function renderLLMAgentModeSection(pageState) {
  const sections = Array.isArray(pageState.llmCapabilitySections) ? pageState.llmCapabilitySections : [];
  return `
    <div class="form-note">Configure route and model defaults per capability. Leave empty to use global default routing.</div>
    <div class="llm-capabilities">
      <div class="llm-capabilities__header">
        <span>Capability</span>
        <span>Route</span>
        <span>Model</span>
      </div>
      ${sections.map(renderCapabilityRow).join("")}
    </div>
  `;
}

function renderCapabilityRow(section) {
  const selectedRoute = section.selectedRoute || null;
  const defaults = section.defaults || { route_id: "", model: "" };
  const routeModels = Array.isArray(section.routeModels) ? section.routeModels : [];
  const datalistID = `agent-llm-model-options-${escapeHTML(section.capability)}`;
  const modelPlaceholder = selectedRoute?.default_model ? selectedRoute.default_model : "Default";
  return `
    <div class="llm-capabilities__row">
      <span class="llm-capabilities__label">${escapeHTML(section.label)}</span>
      <select name="${escapeHTML(section.routeFieldName)}">
        <option value="">Default</option>
        ${section.availableRoutes.map((item) => `<option value="${escapeHTML(item.id)}" ${defaults.route_id === item.id ? "selected" : ""}>${escapeHTML(item.name)}</option>`).join("")}
      </select>
      <div class="llm-capabilities__model">
        <input
          name="${escapeHTML(section.modelFieldName)}"
          ${routeModels.length ? `list="${datalistID}"` : ""}
          placeholder="${escapeHTML(modelPlaceholder)}"
          value="${escapeHTML(defaults.model)}"
        >
        ${routeModels.length ? `
          <datalist id="${datalistID}">
            ${routeModels.map((item) => `<option value="${escapeHTML(item)}"></option>`).join("")}
          </datalist>
        ` : ""}
      </div>
    </div>
  `;
}
